<app-sidebar 
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Consumer">
</app-sidebar>


